import React, { useEffect } from "react";
import { useForm } from 'react-hook-form';

// components
import {
  Card,
  CardHeader,
  Container,
  Row,
  Col,
  Input,
  Button,
  FormGroup, CardBody
} from "reactstrap";
import MaterialTable from "material-table";
import Select from 'react-select'
import Header from "../../../components/Headers/Header.jsx";
import moment from "moment";

//helpers
import { formateDateApi } from "../../../helpers/formats.js";

// services
import { showMessage } from "../../../services/message.js";
import { api_GET, api_POST } from "../../../services/api_service.js";
import { getSessionCookie } from "../../../services/session.js";

//Constants
import { table_translate, table_style } from "../../../constants/MaterialTable.js";

export default function OrdemColetaPesquisa({ history }) {
  const session = getSessionCookie();

  const { register, handleSubmit, errors, setError, setValue, clearErrors } = useForm({ mode: "onBlur" });

  const [list_table, set_list_table] = React.useState([])
  const [list_loading, set_list_loading] = React.useState(false);

  const [dataOrdemColeta, setdataOrdemColeta] = React.useState(formateDateApi(moment(new Date())));
  const handleDataOrdemColetaChange = (value) => {
    setdataOrdemColeta(formateDateApi(value));
  }

  const [optionsModalidadesColeta, setoptionsModalidadesColeta] = React.useState([]);
  const [modalidadeColeta, setModalidadeColeta] = React.useState(null);
  const loadOptionsModalidadesColeta = () => {
    let endpoint = 'modalidadeColeta';
    if (session.concessionariaId != null)
      endpoint += `/GetByConcessionaria/${session.concessionariaId}`;
    api_GET(endpoint).then(result => {
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        result.data.push({ descricao: "Todas", modalidadeColetaId: null });
        setoptionsModalidadesColeta(result.data);
      }
    });
  }

  const [optionsRegional, setOptionsRegional] = React.useState([]);
  const [regional, setRegional] = React.useState(null);
  const loadOptionsRegional = () => {
    if (localStorage.getItem("regionais") != null) {
      let lista = JSON.parse(localStorage.getItem("regionais"));
      lista.push({ descricao: "Todas", regionalId: null });
      setOptionsRegional(lista);
    }
    else {
      api_GET(`regional`).then(result => {
        if (result.status !== 200) {
          showMessage("Aviso", result.message, 'error', null);
        }
        else {
          result.data.push({ descricao: "Todas", regionalId: null });
          setOptionsRegional(result.data);
        }
      });
    }
  }

  const [optionsSetorColeta, setOptionsSetorColeta] = React.useState([]);
  const [setorColeta, setSetorColeta] = React.useState(null);
  const loadOptionsSetorColeta = () => {
    let endpoint = 'SetorColeta';
    if (session.concessionariaId != null)
      endpoint += `/GetByConcessionaria/${session.concessionariaId}`;

    api_GET(endpoint).then(result => {
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        result.data.push({ descricao: "Todos", setorColetaId: null });
        setOptionsSetorColeta(result.data);
      }
    });
  }

  const [optionsVeiculo, setOptionsVeiculo] = React.useState([]);
  const [veiculo, setVeiculo] = React.useState(null);
  const loadOptionsVeiculo = () => {
    let endpoint = 'veiculo';
    if (session.concessionariaId != null)
      endpoint += `/GetByConcessionaria/${session.concessionariaId}`;
    api_GET(endpoint).then(result => {
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        result.data.push({ descricao: "Todos", veiculoId: null });
        setOptionsVeiculo(result.data);
      }
    });
  }

  const optionsStatus = [
    { value: 'Não Programada', label: 'Não Programada' },
    { value: 'Programada', label: 'Programada' },
    { value: 'Em Execução', label: 'Em Execução' },
    { value: 'Em Pausa', label: 'Em Pausa' },
    { value: 'Destinada', label: 'Destinada' },
    { value: 'Finalizada', label: 'Finalizada' },
    { value: '', label: 'Todos' },
  ];
  const [status, setStatus] = React.useState("");

  const GetList = () => {
    set_list_loading(true);

    let json_post = {
      concessionariaId: session.concessionariaId,
      dataProgramacao: dataOrdemColeta != "" ? formateDateApi(dataOrdemColeta) : dataOrdemColeta,
      modalidadeColetaId: modalidadeColeta != null ? modalidadeColeta.modalidadeColetaId : null,
      regionalId: regional != null ? regional.regionalId : null,
      setorColetaId: setorColeta != null ? setorColeta.setorColetaId : null,
      veiculoId: veiculo != null ? veiculo.veiculoId : null,
      statusExecucao: status != "" ? status.value : ""
    }

    api_POST('AvaliacaoColeta/Pesquisa', json_post).then(result => {
      set_list_loading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        set_list_table(result.data);
      }
    });
  }

  useEffect(() => {
    setValue("dataProgramacao", dataOrdemColeta);
    loadOptionsModalidadesColeta();
    loadOptionsRegional();
    loadOptionsVeiculo();
    loadOptionsSetorColeta();
  }, []);

  const hadleBadgeStatusAvaliacao = (status) => {
    switch (status) {
      case "Pendente": return "badge badge-dark";
      case "Não Avaliada": return "badge badge-default";
      case "Aprovação Automática": return "badge badge-success";
      case "Aprovada": return "badge badge-success";
      case "Contestada": return "badge badge-warning";
      case "Justificada": return "badge badge-primary";
      case "Reprovada": return "badge badge-danger";
      default: return ""
    }
  }

  const OpenOrdemColetaMap = (data) => {
    let url = '/mapaordem/analiseordemmap?id=' + data.ordemColetaId
    window.open(url);
  }

  const columnsProp = [
    { title: 'Setor', field: "identificacaoSetor" },
    { title: 'Modalidade', field: "modalidadeColeta" },
    { title: 'Divisão Administrativa', field: "descricaoRegional" },
    { title: 'Placa/Identificação', field: "placa" },
    { title: 'Status Execução', field: "statusExecucao" },
    { title: 'Alertas', field: "totalInconformidades", render: (rowData) => rowData && (<span className={rowData.totalInconformidades > 0 ? "badge badge-warning" : ""}>{rowData.totalInconformidades}</span>) },
    { title: 'Status Avaliação', field: "statusAvaliacao", render: (rowData) => rowData && (<span className={hadleBadgeStatusAvaliacao(rowData.statusAvaliacao)}>{rowData.statusAvaliacao}</span>) },
    { title: 'Responsável', field: "responsavelAvaliacao" },
    { title: 'Percentual de Conclusão', field: "percentualConclusao", render: (rowData) => rowData && (<span>{rowData.percentualConclusao.toFixed(2).replace('.', ',')}%</span>) },
  ]

  return (
    <>
      <Header />
      <Container className="mt--9" fluid>
        <Row>
          <Container className="mt-1" fluid>
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row>
                  <Col md="6">
                    <strong> Pesquisa de Ordens de Serviço</strong>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md="4" lg="3">
                    <FormGroup>
                      <label className="form-control-label" htmlFor="input-address" >
                        Data
                      </label>
                      <Input
                        className="form-control-alternative"
                        innerRef={register()}
                        defaultValue=""
                        name="dataProgramacao"
                        placeholder="Data"
                        type="date"
                        max={formateDateApi(moment(new Date()))}
                        onBlur={(e) => handleDataOrdemColetaChange(e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="8" lg="6">
                    <FormGroup>
                      <label className="form-control-label" htmlFor="input-address" >
                        Modalidade de Serviço
                      </label>
                      <Select
                        name="modalidadeColeta"
                        options={optionsModalidadesColeta}
                        getOptionLabel={({ descricao }) => descricao}
                        getOptionValue={({ modalidadeColetaId }) => modalidadeColetaId}
                        onChange={(value) => { setModalidadeColeta(value) }}
                        value={modalidadeColeta != null && optionsModalidadesColeta.find(obj => obj.modalidadeColetaId === modalidadeColeta.modalidadeColetaId)}
                        placeholder="Todas"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6" lg="3">
                    <FormGroup>
                      <label className="form-control-label" htmlFor="input-address" >
                        Divisão Administrativa
                      </label>
                      <Select
                        name="regional"
                        options={optionsRegional}
                        getOptionLabel={({ descricao }) => descricao}
                        getOptionValue={({ regionalId }) => regionalId}
                        onChange={(value) => { setRegional(value) }}
                        value={regional != null && optionsRegional.find(obj => obj.regionalId === regional.regionalId)}
                        placeholder="Todas"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6" lg="4">
                    <FormGroup>
                      <label className="form-control-label" htmlFor="input-address" >
                        Setor
                      </label>
                      <Select
                        name="setorColeta"
                        options={optionsSetorColeta}
                        getOptionLabel={({ descricao }) => descricao}
                        getOptionValue={({ setorColetaId }) => setorColetaId}
                        onChange={(value) => { setSetorColeta(value) }}
                        value={setorColeta != null && optionsSetorColeta.find(obj => obj.setorColetaId === setorColeta.setorColetaId)}
                        placeholder="Todos"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6" lg="4">
                    <FormGroup>
                      <label className="form-control-label" htmlFor="input-address" >
                        Recurso
                      </label>
                      <Select
                        name="veiculo"
                        options={optionsVeiculo}
                        getOptionLabel={({ placa }) => placa}
                        getOptionValue={({ veiculoId }) => veiculoId}
                        onChange={(value) => { setVeiculo(value) }}
                        value={veiculo != null && optionsVeiculo.find(obj => obj.veiculoId === veiculo.veiculoId)}
                        placeholder="Todos"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6" lg="4">
                    <FormGroup>
                      <label className="form-control-label" htmlFor="input-address" >
                        Status
                      </label>
                      <Select
                        name="status"
                        options={optionsStatus}
                        getOptionLabel={({ label }) => label}
                        getOptionValue={({ value }) => value}
                        onChange={(value) => { setStatus(value) }}
                        value={status != null && optionsStatus.find(obj => obj.value === status)}
                        placeholder="Todos"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="12" lg="12" className="text-center mb-2">
                    <Button outline type="button" color="info" onClick={() => GetList()}>Pesquisar</Button>
                  </Col>
                </Row>
                <Row>
                  <Col md="12" className="mt-1 mb-4">
                    <MaterialTable
                      title="Lista de Ordens de Serviço"
                      columns={columnsProp}
                      data={list_table}
                      isLoading={list_loading}
                      options={{ ...table_style, headerStyle: { zIndex: 0 }, pageSize: 20, pageSizeOptions: [20, 50, list_table.length] }}
                      actions={[
                        {
                          icon: 'edit',
                          tooltip: 'Analisar Ordem de Serviço',
                          onClick: (event, rowData) => OpenOrdemColetaMap(rowData)
                        }
                      ]}
                      localization={table_translate}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Container>
        </Row>
      </Container>
    </>
  );
}
